import { render, staticRenderFns } from "./SiteMaterials.vue?vue&type=template&id=5a0315ca"
import script from "./SiteMaterials.vue?vue&type=script&lang=js"
export * from "./SiteMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports